import { render } from "./FeatherInboxSvg.vue?vue&type=template&id=86baed26"
const script = {}
script.render = render

export default script